export default {"src":"/_next/static/media/clock.1f7cc663.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};